<template>
  <gj-modal
      :visible.sync="modalVisible"
      :destroyOnClose="true"
      :footer="false"
      @open="modalOpen"
      size="full-screen">
    <template #header>
      <div class="header">
        <span>商品运营信息</span>
        <span class="gj-label" style="margin-left: 20px;">店铺/国家：</span><span class="gj-content">Soulen:US</span>
        <el-divider direction="vertical"></el-divider>
        <span class="gj-label">ASIN：</span><span class="gj-content">B01LVTW1FO</span>
        <el-divider direction="vertical"></el-divider>
        <span class="gj-label">MSKU：</span><span class="gj-content">B01LVTW1FO</span>
        <el-divider direction="vertical"></el-divider>
        <span class="gj-label">父ASIN：</span><span class="gj-content">B01LVTW1FO</span>
      </div>
    </template>
    <template #content>
      <div class="analysis-content">
        <div>
          <el-row type="flex" style="padding: 0 10px;">
            <gj-image
                src="https://m.media-amazon.com/images/I/41+YqCDAcxL.jpg"
                :size="65"></gj-image>
            <div style="flex: 1; margin-left: 20px;">
              <div class="gj-mb10">
                <gj-tooltip :content="title">
              <span class="product-name text-ellipsis-1">
                {{title}}
              </span>
                </gj-tooltip>
              </div>
              <el-row class="gj-mb10">
                <el-col :span="5">
                  <div class="text-ellipsis-1">
                    <span class="gj-label">SKU：</span>
                    <gj-tooltip content="21-MSS3P4S-CL">
                      <span class="gj-content">21-MSS3P4S-CL</span>
                    </gj-tooltip>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="text-ellipsis-1">
                    <span class="gj-label">产品负责人：</span>
                    <gj-tooltip content="21-MSS3P4S-CL">
                      <span class="gj-content">alisa</span>
                    </gj-tooltip>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="text-ellipsis-1">
                    <span class="gj-label">产品名称：</span>
                    <gj-tooltip content="21-MSS3P4S-CL">
                      <span class="gj-content">（轻小）斜切美妆蛋3个装（玫红、黑色、紫色）</span>
                    </gj-tooltip>
                  </div>
                </el-col>
              </el-row>
              <el-row class="gj-mb10">
                <el-col :span="5">
                  <el-rate
                      :value="4.6"
                      disabled
                      class="rate"
                      text-color="#ff9900">
                  </el-rate>
                  <span class="gj-content rate-score">4.6</span>
                  <span class="gj-content">(953)</span>
                </el-col>
                <el-col :span="4">
                  <div class="text-ellipsis-1">
                    <span class="gj-label">销售负责人：</span>
                    <gj-tooltip content="21-MSS3P4S-CL">
                      <span class="gj-content">Cecilia</span>
                    </gj-tooltip>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="text-ellipsis-1">
                    <span class="gj-label">销售排名：</span>
                    <gj-tooltip content="21-MSS3P4S-CL">
                      <span class="gj-content">#1,173 in Beauty & Personal Care #6 in Makeup Blenders & Sponges</span>
                    </gj-tooltip>
                  </div>
                </el-col>
                <el-col :span="7">
                  <div class="text-ellipsis-1" style="margin-left: 10px;">
                    <span class="gj-label">售价：</span>
                    <span class="gj-content">$3.29</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-row>
          <el-divider></el-divider>
          <app-filter-group
              :reset="false"
              :query="false">
            <gj-date-picker
                type="daterange"
            ></gj-date-picker>
            <gj-radio-group
                v-model="dateType"
                :options="[
                  {id: 'day', text: '日'},
                  {id: 'week', text: '周'},
                  {id: 'month', text: '月'},
                ]">
            </gj-radio-group>
            <template #right>
              <gj-tool-group
                  :modal-mount-to="$mountTo"
                  setting :table-name="tableName" :table-columns="columns"
              ></gj-tool-group>
              <gj-radio-group
                  :value="viewType"
                  @input="changViewType($event)"
                  :options="[
                    {id: 'chart', text: '图表'},
                    {id: 'list', text: '列表'},
                  ]">
              </gj-radio-group>
            </template>
          </app-filter-group>
          <div v-show="viewType === 'list'" class="content-table">
            <gj-table
                :name="tableName"
                :data="tableData"
                :columns="columns"
                :default-sort = "{prop: 'date', order: 'descending'}"
                :offset-height="280"
                :show-summary="true">
            </gj-table>
          </div>
          <div v-show="viewType === 'chart'" class="content-options">
            <el-row>
              <el-col class="option-container" :span="8">
                <el-row>
                  <el-col v-for="item in salesAnalysisOption" :key="item.id" :span="6">
                    <el-row class="analysis-legend" type="flex" align="middle">
                      <div :style="{backgroundColor: item.color}" class="analysis-legend--icon"></div>
                      <div class="analysis-legend--label">{{item.text}}</div>
                    </el-row>
                  </el-col>
                </el-row>
                <div class="option-divider"></div>
              </el-col>
              <el-col class="option-container" :span="8">
                <el-row>
                  <el-col v-for="item in flowAnalysisOption" :key="item.id" :span="6">
                    <el-row class="analysis-legend" type="flex" align="middle">
                      <div :style="{backgroundColor: item.color}" class="analysis-legend--icon"></div>
                      <div class="analysis-legend--label">{{item.text}}</div>
                    </el-row>
                  </el-col>
                </el-row>
                <div class="option-divider"></div>
              </el-col>
              <el-col class="option-container" :span="4">
                <el-row>
                  <el-col v-for="item in rankAnalysisOption" :key="item.id" :span="12">
                    <el-row class="analysis-legend" type="flex" align="middle">
                      <div :style="{backgroundColor: item.color}" class="analysis-legend--icon"></div>
                      <div class="analysis-legend--label">{{item.text}}</div>
                    </el-row>
                  </el-col>
                </el-row>
                <div class="option-divider"></div>
              </el-col>
              <el-col class="option-container" :span="4">
                <el-row>
                  <el-col v-for="item in storageAnalysisOption" :key="item.id" :span="12">
                    <el-row class="analysis-legend" type="flex" align="middle">
                      <div :style="{backgroundColor: item.color}" class="analysis-legend--icon"></div>
                      <div class="analysis-legend--label">{{item.text}}</div>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
        <div v-show="viewType === 'chart'" ref="chart" style="flex: 1;"></div>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";

  export default {
    name: "app-operation-analysis-modal",
    mixins: [modalMixIn],
    data() {
      return {
        tableName: 'operation-analysis-table',
        title: 'Makeup Sponges, Larbois 3-Pack Blender Beauty Foundation Blending Sponge, Professional Beauty Makeup Set for Dry & Wet Use (Oblique)',
        tableData: [{
          date: '2019-01-01',
        }],
        columns: [
          {id: '1', header: '统计日期', field: 'date', width: '90px', fixed: 'left', sortable: true, notCustomColumn: true},
          {id: '2', header: '销量', field: 'date', width: '80px', sortable: true, align: 'right', default: true},
          {id: '3', header: '订单量', field: '1', width: '80px', sortable: true, align: 'right', default: true},
          {id: '4', header: '销售额', field: '1', width: '80px', sortable: true, align: 'right', default: true},
          {id: '5', header: '总费用', field: '1', width: '90px', help: '总费用= 采购成本+到库成本+VAT+MFN订单运费+订单扣费+订单退款+补单扣费+多渠道订单扣费+广告花费',
            sortable: true, align: 'right', default: true},
          {id: '6', header: '销售毛利', field: '1', width: '90px', sortable: true, align: 'right', default: true},
          {id: '7', header: '销售毛利率', field: '1', width: '100px', sortable: true, align: 'right', default: true},
          {id: '8', header: '退货量', field: '1', width: '70px', sortable: true, align: 'right'},
          {id: '9', header: '退货率', field: '1', width: '70px', sortable: true, align: 'right'},
          {id: '10', header: '退款量', field: '1', width: '70px', sortable: true, align: 'right'},
          {id: '11', header: '退款率', field: '1', width: '70px', sortable: true, align: 'right'},
          {id: '12', header: '退款销售额', field: '1', width: '95px', sortable: true, align: 'right'},
          {id: '13', header: 'FBA发货费', field: '1', width: '95px', sortable: true, align: 'right'},
          {id: '14', header: '平均FBA发货费', field: '1', help: '平均FBA配送费=FBA配送费/销量', width: '135px', sortable: true, align: 'right'},
          {id: '15', header: '销售佣金', field: '1', width: '90px', sortable: true, align: 'right'},
          {id: '16', header: '促销折扣', field: '1', width: '90px', sortable: true, align: 'right'},
          {id: '17', header: '采购成本', field: '1', width: '90px', sortable: true, align: 'right'},
          {id: '18', header: '到库成本', field: '1', width: '90px', sortable: true, align: 'right'},
          {id: '19', header: '排名', field: '1', width: '70px', sortable: true, align: 'right', default: true},
          {id: '20', header: '售价', field: '1', width: '70px', sortable: true, align: 'right', default: true},
          {id: '21', header: '星级', field: '1', width: '70px', sortable: true, align: 'right', default: true},
          {id: '22', header: '评论数', field: '1', width: '70px', sortable: true, align: 'right', default: true},
          {id: '23', header: '留评率', field: '1', width: '90px', help: '近30天留评数/近30天销量', sortable: true, align: 'right', default: true},
          {id: '24', header: '广告曝光量', field: '1', width: '100px', sortable: true, align: 'right', default: true},
          {id: '25', header: '广告点击量', field: '1', width: '100px', sortable: true, align: 'right', default: true},
          {id: '26', header: 'CTR', field: '1', width: '80px', help: '点击率=广告点击量/广告曝光量', sortable: true, align: 'right', default: true},
          {id: '27', header: '广告订单量', field: '1', width: '100px', sortable: true, align: 'right', default: true},
          {id: '28', header: '广告CVR', field: '1',  width: '100px',  help: '广告转化率=广告订单量/广告点击量',sortable: true, align: 'right', default: true},
          {id: '29', header: '广告花费', field: '1', width: '90px', sortable: true, align: 'right', default: true},
          {id: '30', header: '广告销售额', field: '1', width: '100px', sortable: true, align: 'right', default: true},
          {id: '31', header: 'ACoS', help: 'ACoS=广告花费/广告销售额', field: '1', width: '90px', sortable: true, align: 'right', default: true},
          {id: '32', header: 'ACoAS', help: 'ACoAS=广告花费/销售额', field: '1', width: '100px', sortable: true, align: 'right', default: true},
          {id: '33', header: 'ASoAS', help: 'ASoAS=广告销售额/销售额', field: '1', width: '90px', sortable: true, align: 'right', default: true},
          {id: '34', header: '可售量', field: '1', width: '80px', sortable: true, align: 'right'},
          {id: '35', header: '已下单量', field: '1', width: '90px', sortable: true, align: 'right'},
          {id: '36', header: '计划入库量(FBA)', field: '1', width: '128px', sortable: true, align: 'right'},
          {id: '37', header: '待入库量(FBA)', field: '1', width: '120px', sortable: true, align: 'right'},
          {id: '38', header: '库周转', field: '1', width: '80px', sortable: true, align: 'right'},
        ],
        salesAnalysisOption: [
          {id: 'unitsOrdered', text: '销量', color: '#8543E0'},
          {id: 'orders', text: '订单量', color: '#738AE6'},
          {id: 'orderProductSales', text: '销售额', color: '#5CA3E6'},
          {id: 'totalFee', text: '总费用', color: '#A877ED', title: '总费用=采购成本+到库成本+VAT+MFN订单运费+订单扣费+订单退款+补单扣费+多渠道订单扣费+广告花费'},
          {
            id: 'salesGrossProfit',
            text: '销售毛利',
            color: '#89C3EB',
            title: '销售毛利=实际销售额+采购成本+到库成本+税+MFN订单运费+订单扣费+订单退款+退货补回采购成本+退货补回到库成本+退款补回税+补单扣费+多渠道订单扣费+测评费用'
          },
          {id: 'grossProfitRate', text: '销售毛利率', color: '#9AE65C', title: '销售毛利率=销售毛利/销售额'},
          {id: 'returns', text: '退货量', color: '#CCA6BF'},
          {id: 'returnsRate', text: '退货率', color: '#D4ACAD', title: '退货率=退货量/销量'},
          {id: 'refunds', text: '退款量', color: '#d4ce50'},
          {id: 'refundsRate', text: '退款率', color: '#8bd3d4'},
          {id: 'returnProductSales', text: '退款销售额', color: '#c7d46c'},
          {id: 'fbaShipmentFee', text: 'FBA发货费', color: '#AD7C58'},
          {id: 'avgFbaShipmentFee', text: '平均FBA发货费', color: '#ad0b54', title: '平均FBA发货费=FBA发货费/销量'},
          {id: 'salesCommission', text: '销售佣金', color: '#FA7D92'},
          {id: 'promotionDiscount', text: '促销折扣', color: '#1890FF'},
          {id: 'purchaseCost', text: '采购成本', color: '#57AD71'},
          {id: 'arriveCost', text: '到库成本', color: '#E6965C'},
        ],
        flowAnalysisOption: [
          {id: 'adsImpressions', text: '广告曝光量', color: '#02A7F0'},
          {id: 'adsClicks', text: '广告点击量', color: '#F04864'},
          {id: 'ctr', text: 'CTR', color: '#7564CC', title: '点击率=广告点击量/广告曝光量'},
          {id: 'adsOrders', text: '广告订单量', color: '#C7DB68'},
          {id: 'cr', text: '广告CVR', color: '#c9d32c'},
          {id: 'adsSpend', text: '广告花费', color: '#A68F87'},
          {id: 'adsSales', text: '广告销售额', color: '#D3CBD6'},
          {id: 'acoS', text: 'ACoS', color: '#EE837D', title: 'ACoS=广告花费/广告销售额'},
          {id: 'acoAS', text: 'ACoAS', color: '#B79B5A', title: 'ACoAS=广告花费/销售额'},
          {id: 'asoAS', text: 'ASoAS', color: '#C7C2BE', title: 'ASoAS=广告销售额/销售额'},
        ],
        rankAnalysisOption: [
          {id: 'sellerRank', text: '排名', color: '#8082FF'},
          {id: 'salesPrice', text: '售价', color: '#6EDB8F'},
          {id: 'star', text: '星级', color: '#41D9C7'},
          {id: 'reviewQuantity', text: '评论数', color: '#FACC14'},
          {id: 'reviewRate', text: '留评率', color: '#A6A5C4', title: '近30天留评数/近30天销量'},
        ],
        storageAnalysisOption: [
          {id: 'availableQuantity', text: '可售量', color: '#66B5FF'},
          {id: 'orderPlacedQuantity', text: '已下单量', color: '#2FC25B'},
          {id: 'planStorageQuantity', text: '计划入库量(FBA)', color: '#DD81E6'},
          {id: 'waitStorageQuantity', text: '待入库量(FBA)', color: '#9079AD'},
          {id: 'libraryTurnover', text: '库周转', color: '#E09E86'},
        ],
        dateType: 'day',
        viewType: 'chart',
        chart: null,
        chartOption: null
      }
    },
    methods: {
      changViewType(viewType) {
        this.viewType = viewType;
        if (viewType === 'chart') {
          this.renderChart();
        }
      },
      modalOpen() {
        this.$nextTick(() => this.renderChart());
      },
      renderChart() {
        const chartRef = this.$refs.chart;
        if (chartRef) {
          if (!this.chart) {
            this.chart = this.$echarts.init(chartRef);
            this.chartOption = {
              color: ["#4EB3F8", "#64DAB4", "#E98EBB", '#F8D062', '#B57FD1'],
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                show: false
              },
              dataZoom: [
                {
                  show: true,
                  realtime: true,
                },
                // {
                //   type: 'inside',
                //   realtime: true,
                // }
              ],
              grid: {
                top: 20,
                left: '2%',
                right: '2%',
                bottom: 60,
                containLabel: true
              },
              xAxis: {
                axisLabel: {
                  color: "#8b93a6"
                },
                axisLine: {
                  lineStyle: {
                    color: "#e5e9f2"
                  }
                },
                data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
              },
              yAxis: {
                name: "",
                position: "left",
                axisLabel: {
                  margin: 4,
                  formatter: function (e) {
                    var t = Math.abs(e);
                    return t >= 1e4 && t < 1e7 ?
                      t = t / 1e4 + "万" :
                      t >= 1e7 && (t = t / 1e7 + "千万"), t;
                  },
                  color: "#888"
                },
                splitLine: {
                  lineStyle: {
                    type: "dotted",
                    color: "#e5e9f2"
                  }
                },
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "#FFF"
                  }
                }
              },
              series: [
                {
                  name: '销售额',
                  type: 'line',
                  stack: '总量',
                  data: [120, 132, 101, 134, 90, 230, 210]
                },
                {
                  name: '销量',
                  type: 'line',
                  stack: '总量',
                  data: [220, 182, 191, 234, 290, 330, 310]
                },
                {
                  name: '订单量',
                  type: 'line',
                  stack: '总量',
                  data: [150, 232, 201, 154, 190, 330, 410]
                },
                {
                  name: '客单价',
                  type: 'line',
                  stack: '总量',
                  data: [320, 332, 301, 334, 390, 330, 320]
                },
                {
                  name: '退款量',
                  type: 'line',
                  stack: '总量',
                  data: [820, 932, 901, 934, 1290, 1330, 1320]
                }
              ]
            };
            this.chart.setOption(this.chartOption);
            window.addEventListener("resize", function () {
              this.chart.resize()
            });
            this.$on('hook:destroyed', () => {
              window.removeEventListener("resize", function () {
                this.chart.resize();
              });
            });
          } else {
            this.chart.setOption(this.option, true);
          }
        }
      }
    }
  }
</script>

<style scoped>
  .gj-content {
    color: #303133;
    font-weight: 500;
  }
  .rate {
    display: inline-block;
  }
  .rate-score {
    margin: 0 5px;
  }
  .header /deep/ .el-divider {
    background-color: #303133;
  }
  .analysis-content /deep/ .el-divider {
    margin: 6px 0 10px 0;
  }
  .product-name {
    color: #303133;
    font-size: 15px;
    font-weight: bold;
    display: inline-block;
  }
  .gj-mb10 {
    margin-bottom: 6px;
  }
  .analysis-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .analysis-legend {
    line-height: 30px;
  }
  .analysis-legend--icon {
    height: 3px;
    width: 15px;
  }
  .analysis-legend--label {
    margin-left: 8px;
    color: rgba(0,0,0,0.65);
    font-size: 12px;
  }
  .content-options {
    margin: 10px 0;
  }
  .option-container {
    position: relative;
  }
  .option-divider {
    margin-right: 20px;
    position: absolute;
    height: 90px;
    width: 1px;
    border-left: 1px solid #e6e6e6;
    top: 0;
    right: 0;
  }
</style>
